export default {"src":"/_next/static/image/public/images/ic_timer_red.f15c40d5647fb6fd7e375a459312eb81.svg","height":18,"width":16};